import { render, staticRenderFns } from "./CommonChat.vue?vue&type=template&id=558c798e&"
import script from "./CommonChat.vue?vue&type=script&lang=js&"
export * from "./CommonChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports